module.exports = __webpack_public_path__ + "img/logo.e1dff637.svg";